// extracted by mini-css-extract-plugin
module.exports = {"courseStatus":"components_courseStatus__aNVwo","courseStatusLive":"components_courseStatusLive__2OXeC","courseStatusDraft":"components_courseStatusDraft__1zrJL"};